import { ColorVariables } from "manifest-components/src/Colors";
import styled from "styled-components";

export const TransferStatusTileContainer = styled.div`
  background: white;
  border-radius: 5px;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.05);
  width: 100%;
`;

export const TransferStatusTileHeader = styled.div`
  display: flex;
  padding: 30px 26px;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid ${ColorVariables.coco1};
  @media (min-width: 769px) {
    padding: 30px 60px;
  }
`;

export const TransferStatusTileHeaderContent = styled.div`
  display: flex;
  margin-left: 34px;
  flex-direction: column;
  align-items: flex-start;

  .source,
  .destination {
    display: flex;
    align-items: center;
  }

  .label {
    width: 46px;
  }

  .destination {
    margin-top: 10px;
  }
`;

export const TransferStatusTileAccordion = styled.button`
  width: 100%;
  overflow: hidden;
`;

export const TransferStatusTileAccordionHeader = styled.div`
  display: flex;
  padding: 18px 26px;
  display: flex;
  align-items: center;

  .transfer-status-heading {
    flex: 1;
    text-align: left;
    padding-left: 26px;
  }

  @media (min-width: 769px) {
    padding: 18px 60px;
  }
`;

export const TransferStatusTileAccordionIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
`;

export const TransferStatusTileAccordionContent = styled.div<{ $isOpened: boolean }>`
  height: ${(props) => (props.$isOpened ? "auto" : "0")};
  text-align: left;
  color: ${ColorVariables.coco7};
  padding: ${(props) => (props.$isOpened ? "8px" : "0px")} 26px;
  padding-bottom: ${(props) => (props.$isOpened ? "30px" : "0px")};

  @media (min-width: 769px) {
    padding: ${(props) => (props.$isOpened ? "8px" : "0px")} 60px;
    padding-bottom: ${(props) => (props.$isOpened ? "30px" : "0px")};
  }
`;
